exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".notification{position:fixed;top:-100%;width:100%;height:auto;padding:20px 40px 20px 20px;z-index:-1;opacity:0;color:#fff;text-align:center;transition:all 0.25s ease-in-out;box-shadow:0px 2px 6px rgba(0,0,0,0.2)}.notification.show-notification{z-index:800;opacity:1;top:0px}.notification.show-notification.affix-top{top:65px}@media screen and (max-width: 767px){.notification.show-notification.affix-top{top:60px}}.notification .notification-body{position:relative;font-size:18px;font-weight:700;line-height:20px;text-shadow:0px 1px 2px rgba(0,0,0,0.25)}.notification.notification-success{background-color:#93c47d}.notification.notification-error{background-color:#e06666}.notification.notification-warning{background-color:orange}.notification.notification-info{background-color:skyblue}.notification i.fa-times{position:absolute;right:-20px;top:50%;transform:translate(0, -50%)}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Component/Notification.scss
// module id = 1099
// module chunks = 0